<div *ngIf="display">
  <div class="loadingBar_1">
      <div class="spinner-loader loadingBar_2">
        <output *ngIf="display" class="spinner-border spinnerBootStrap">
        </output>
      </div>
  </div>
</div>
